<script lang="ts" setup>
import type { Suggestion as LocationSuggestion } from '~/composables/useLocationAutocomplete';
import type { HTMLAttributes } from 'vue';

import { CommandItem } from '@/components/SearchSuggestRadixCommand';
import Tag from '@/components/ui/tag/Tag.vue';
import { cn } from '@/utils';
import { getBoldMatchCaracteres } from '~~/utils';

defineProps<{
	suggestion: LocationSuggestion;
	isRemovable: boolean;
	searchTerm: string;
	groupItemWrapperClasses?: HTMLAttributes['class'];
	groupItemTextClasses?: HTMLAttributes['class'];
	groupItemSubTextClasses?: HTMLAttributes['class'];
}>();

const emit = defineEmits<{
	(e: 'remove-suggestion', suggestion: LocationSuggestion): void;
}>();
</script>

<!-- * The getBoldMatchCaracteres function already sanitizes the HTML content, so it is safe to use v-html here -->
<!-- eslint-disable vue/no-v-html -->
<template>
	<CommandItem
		:value="suggestion"
		:class="[
			cn(
				'flex flex-col items-start py-2 pl-12 pr-4 data-highlighted:bg-white-dark-2',
				groupItemWrapperClasses
			),
			{
				'flex flex-row items-center justify-between': isRemovable
			}
		]"
	>
		<div :class="{ contents: !isRemovable }">
			<p
				:class="
					cn(
						'text-start text-base font-normal leading-normal text-primary',
						groupItemTextClasses
					)
				"
				v-html="getBoldMatchCaracteres(suggestion.result.title, searchTerm)"
			/>
			<small
				:class="
					cn(
						'text-start text-xs font-normal leading-normal text-primary-light-2',
						groupItemSubTextClasses
					)
				"
			>
				{{ suggestion.result.subtitle }}
			</small>
		</div>

		<div v-if="isRemovable" class="flex items-center justify-center gap-2">
			<IconMaterialSymbolsLightClose
				class="size-5 cursor-pointer"
				:class="groupItemSubTextClasses"
				@click.stop="emit('remove-suggestion', suggestion)"
			/>
		</div>
	</CommandItem>
</template>
